import customProperties from "./customPropertiesService";

const PREFIX = "SharedoTemplateId_";

const get = async () => {
    const props = await customProperties.find(p => p.key.startsWith(PREFIX));
    if (props && props.length > 0) {
        return props.map(p => p.value);
    }

    return [];
}

const nextIndex = async () => {
    const existingKeys = await customProperties.getKeys(key => key.startsWith(PREFIX));

    if (existingKeys && existingKeys.length > 0) {
        const lastIndex = existingKeys.reduce((idx, current) => {
            const idxRegex = new RegExp(`^${PREFIX}_(?<idx>[0-9]+)$`, "g");
            const match = idxRegex.exec(current);
            if (match !== null) {
                const newIdx = parseInt(match.groups.idx, 10);
                return newIdx > idx ? newIdx : idx;
            }

            return idx;
        }, -1);

        return lastIndex + 1;
    }

    return 0;
}

const link = async systemName => {
    const nextIdx = await nextIndex();
    await customProperties.set(`${PREFIX}_${nextIdx}`, systemName);
}

const unlink = async systemName => {
    const properties = await customProperties.find(p => p.key.startsWith(PREFIX) && p.value === systemName);
    if (properties) {
        for (let i = 0; i < properties.length; i++) {
            await customProperties.remove(properties[i].key);
        }
    }
}

export default {
    get,
    link,
    unlink
}